module.exports = __webpack_public_path__ + "img/news_1_03.25aa25b5.jpg";